

<script>
	import tableBase from '@_system/components/base/table.vue'
	export default {
		extends: tableBase,
		props: {

		},
		data() {
			return {
				list_autorender:false,
				gridKey: Math.random(),
				gridOptions: null,
			}
		},
		watch: {

		},
		created() {
			
		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {

		}
	}
</script>
